var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress-bar-fill",style:({ width: _vm.completed + '%' })},[_c('span',{staticClass:"progress-bar-label"},[_vm._v(_vm._s(_vm.completed)+"%")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }